import { Table, styled } from "@mui/material";

export const StyledTable = styled(Table)(({ theme }) => ({
  thead: {
    background: theme.palette.mode === "dark" ? "#1E1E1E" : "#F7F7F7",
  },
  th: {
    padding: "4px",
    lineHeight: "18px",
    fontWeight: 700,
  },
  td: {
    padding: "4px",
  },
}));
